var _classCallCheck = require("/var/lib/jenkins/workspace/deploy-prod-frontend/frontend_src_repo/frontend-v1/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/var/lib/jenkins/workspace/deploy-prod-frontend/frontend_src_repo/frontend-v1/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
/**
 * @module buffer-reader
 * 
 * @description
 * Exports a class {@link BufferReader}, used internally to handle 
 * access when an input buffer is passed. This provides a consistent
 * interface between reading from files and buffers, so that in-memory
 * files can be handled efficiently.
 */
/**
 * A class that allows a reader to access file through the file system.
 * This can be used as an alternative to the 
 * [FileReader]{@link module:file-reader~FileReader} which
 * reads direct from an opened file descriptor. 
 */
var BufferReader = /*#__PURE__*/function () {
  "use strict";

  function BufferReader(buffer) {
    _classCallCheck(this, BufferReader);
    this._buffer = buffer;
  }
  _createClass(BufferReader, [{
    key: "open",
    value: function open() {
      return Promise.resolve();
    }
  }, {
    key: "close",
    value: function close() {
      return Promise.resolve();
    }
  }, {
    key: "read",
    value: function read(buffer, offset, length, position) {
      this._buffer.copy(buffer, offset, position, position + length);
      return Promise.resolve(buffer);
    }
  }, {
    key: "buffer",
    value: function buffer() {
      return this._buffer;
    }
  }], [{
    key: "isBufferReader",
    value: function isBufferReader(instance) {
      return instance instanceof BufferReader;
    }
  }]);
  return BufferReader;
}();
module.exports = BufferReader;